import React, { useState, useEffect } from "react";
import html2canvas from "html2canvas";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";
import "./IdCard.css";
import sign from "./signature.png";

const StudentIdCard = () => {
  const { studentRegNumber } = useParams();
  const navigate = useNavigate();
  const [idCardData, setIdCardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIdCard = async () => {
      try {
        const idCardRef = doc(db, 'idCards', studentRegNumber);
        const idCardDoc = await getDoc(idCardRef);
        
        if (idCardDoc.exists()) {
          setIdCardData(idCardDoc.data());
        } else {
          setError('ID Card not found');
        }
      } catch (err) {
        console.error('Error fetching ID card:', err);
        setError('Failed to load ID card');
      } finally {
        setLoading(false);
      }
    };

    if (studentRegNumber) {
      fetchIdCard();
    }
  }, [studentRegNumber]);

  const saveCardAsImage = (selector, filename) => {
    const card = document.querySelector(selector);
    if (!card) return;

    html2canvas(card, {
      scale: 3,
      backgroundColor: null,
      useCORS: true,
    }).then((canvas) => {
      const link = document.createElement("a");
      link.download = filename;
      link.href = canvas.toDataURL("image/png");
      link.click();
    });
  };

  if (loading) {
    return (
      <div className="page" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
        <div style={{ 
          textAlign: 'center', 
          padding: '40px',
          background: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}>
          <div style={{ 
            border: '4px solid #667eea',
            borderTop: '4px solid transparent',
            borderRadius: '50%',
            width: '50px',
            height: '50px',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p style={{ fontSize: '18px', color: '#2d3748', fontWeight: '600' }}>Loading ID Card...</p>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error || !idCardData) {
    return (
      <div className="page" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)' }}>
        <div style={{ 
          textAlign: 'center', 
          padding: '40px',
          background: 'white',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          maxWidth: '500px',
          margin: '0 auto'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>⚠️</div>
          <p style={{ color: '#e53e3e', fontSize: '20px', fontWeight: '600', marginBottom: '20px' }}>
            {error || 'ID Card not available'}
          </p>
          <button 
            onClick={() => navigate('/student')}
            style={{
              padding: '12px 24px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)'
            }}
          >
            Go Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="page" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', padding: '20px' }}>
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto',
        textAlign: 'center'
      }}>
        <h1 style={{ 
          color: '#2d3748', 
          marginBottom: '30px',
          fontSize: '32px',
          fontWeight: '700',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          Student ID Card
        </h1>
      </div>
      
      {/* Horizontal Card */}
      <div className="id-card horizontal">
        {/* Header */}
        <div className="header">
          <div className="logo">
            <img src="/numl.png" alt="NUML Logo" crossOrigin="anonymous" />
          </div>
          <div className="meow">
            <div className="header-text">
              NATIONAL UNIVERSITY OF MODERN LANGUAGES
            </div>
            <div className="sub-header">Lahore Campus</div>
          </div>
        </div>

        {/* Contact */}
        <div className="contact">
          <div className="tel">Tel: 042-99204588</div>
          <div className="web">www.numl.edu.pk</div>
        </div>

        {/* Info */}
        <div className="info">
          <div className="details">
            <div>
              <b>Name:</b> {idCardData.name}
            </div>
            <div>
              <b>Class:</b> {idCardData.className}
            </div>
            <div>
              <b>SYS ID:</b> {idCardData.sysId}
            </div>
            <div>
              <b>Session:</b> {idCardData.session}
            </div>
            <div>
              <b>CNIC #:</b> {idCardData.cnic}
            </div>
          </div>
          <div className="photo">
            {idCardData.photoUrl ? (
              <img src={idCardData.photoUrl} alt="Student" crossOrigin="anonymous" />
            ) : (
              <div style={{ 
                width: '100%', 
                height: '100%', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                backgroundColor: '#f0f0f0',
                color: '#666'
              }}>
                No Photo
              </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="footer">
          <div className="signature">
            <img src={sign} alt="Signature" crossOrigin="anonymous" />
          </div>
          Regional Director
        </div>
      </div>

      {/* Buttons */}
      <div className="actions" style={{ marginTop: '30px', marginBottom: '40px' }}>
        <button 
          className="print-btn" 
          onClick={() => window.print()}
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '14px 28px',
            fontSize: '16px',
            fontWeight: '600',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
          }}
        >
          🖨️ Print Card
        </button>
        <button
          className="print-btn"
          onClick={() => saveCardAsImage(".horizontal", `id-card-${studentRegNumber}.png`)}
          style={{
            background: 'linear-gradient(135deg, #48bb78 0%, #38a169 100%)',
            padding: '14px 28px',
            fontSize: '16px',
            fontWeight: '600',
            boxShadow: '0 4px 15px rgba(72, 187, 120, 0.4)'
          }}
        >
          💾 Download as PNG
        </button>
        <button
          className="print-btn"
          onClick={() => navigate('/student')}
          style={{
            background: 'linear-gradient(135deg, #718096 0%, #4a5568 100%)',
            padding: '14px 28px',
            fontSize: '16px',
            fontWeight: '600',
            boxShadow: '0 4px 15px rgba(113, 128, 150, 0.4)'
          }}
        >
          ← Back to Dashboard
        </button>
      </div>

      {/* Vertical Card */}
      <div className="id-card vertical">
        <div className="header vertical-header">
          <div className="logo">
            <img src="/numl.png" alt="NUML Logo" crossOrigin="anonymous" />
          </div>
          <div className="header-text">
            NATIONAL UNIVERSITY OF MODERN LANGUAGES
          </div>
          <div className="sub-header">Lahore Campus</div>
        </div>

        <div className="photo vertical-photo">
          {idCardData.photoUrl ? (
            <img src={idCardData.photoUrl} alt="Student" crossOrigin="anonymous" />
          ) : (
            <div style={{ 
              width: '100%', 
              height: '100%', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              backgroundColor: '#f0f0f0',
              color: '#666'
            }}>
              No Photo
            </div>
          )}
        </div>

        <div className="details vertical-details">
          <div>
            <b>Name:</b> {idCardData.name}
          </div>
          <div>
            <b>Class:</b> {idCardData.className}
          </div>
          <div>
            <b>SYS ID:</b> {idCardData.sysId}
          </div>
          <div>
            <b>Session:</b> {idCardData.session}
          </div>
          <div>
            <b>CNIC #:</b> {idCardData.cnic}
          </div>
        </div>

        {/* Footer with Signature (Vertical) */}
        <div className="footer">
          <div className="signature">
            <img src={sign} alt="Signature" crossOrigin="anonymous" />
          </div>
          Regional Director
        </div>
      </div>
    </div>
  );
};

export default StudentIdCard;

